import { Injectable } from '@angular/core';
import { PageModel } from '../Models/page-model';
import { PageMock } from '../DataStore/Mock/page-mock';
import { Observable } from 'rxjs';
import { RestService } from './rest.service';
import { ProjectService } from './project.service';

@Injectable({
  providedIn: 'root'
})
export class PageServiceService {

  constructor(public rest: RestService) { }
  webpages = new Observable();
  webobjecttype = new Observable();
  webobjects = new Observable();
  public findByObjectId(id: string): Observable<any> {
    let projectId = localStorage.getItem("projectId");
    return this.rest.get('webpagedetails', projectId);
  }
  public findById(id: number): PageModel {
    return PageMock.findById(id);
  }
  public getItems(): Observable<PageModel[]> {
    let projectId = localStorage.getItem("projectId");
    return this.rest.get('projectwebpage', projectId);
  }
  public getdb2Items(): Observable<PageModel[]> {
    let projectId = localStorage.getItem('projectIdDb2');
    return this.rest.get('projectwebpagedb2', projectId);
  }
  public deletePage(webpage) {
    return PageMock.delete(webpage);
  }
  public editWebObject(webpage) { }
  public getWebObjectListByWebPage(webpage) { }
  public editWebpage(webpage) { }
  public addWebPage(webpage) {
    let projectId = localStorage.getItem("projectId");
    var data = {
      project: { _id: projectId },
      webPage: webpage
    };
    return this.rest.put('addwebpage', data);
  }
  public addWebPagedb2(webpage) {
    let projectId = localStorage.getItem('projectIdDb2');
    let defaultPage = webpage.defaultPage ? 1 : 0;
    delete webpage.defaultPage;
    var data = {
      project: { _id: projectId },
      webPage: webpage,
      isDefaultPage: defaultPage
    };
    return this.rest.put('addwebpagedb2', data);
  }
  public updatePage(webpage) {
    let projectId = localStorage.getItem("projectId");
    if (webpage.webobjects)
      webpage.webobjects = webpage.webobjects.map(eve => { return eve = eve._id });
    var data = {
      project: { _id: projectId },
      webPage: webpage
    };
    return this.rest.post('updatewebpage', data);
  }
  public getWebObjectTypeList() { }
  public addWebObject(webpage) { }
  public getWebpageList(webpage) { }
}
